import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  CardHeader,
  Table,
  Label,
} from "reactstrap";
import Breadcrumbs from "../../../Components/Common/BreadCrumbs";
import Schedule1 from "./Schedule/ScheduleCompononent1";
import Schedule2 from "./Schedule/ScheduleComponent2";
import Schedule3 from "./Schedule/ScheduleComponent3";
import ModalReport from "./Modal/modal";
import Stepper from "react-stepper-horizontal";
import ReportButton from "./Button/Button";
import options from "./data/organizationimg";
import ShowLogo from "./ShowLogo";
import data from "./data/data";
import { useParams } from "react-router";
import ToggleSubmittedReport from "./DetailPageReport/ToggleSubmittedReport";

const ReportDetail = () => {
  const { id } = useParams();

  const [reportStatus, setReportStatus] = useState("new report");
  const [activeStep, setActiveStep] = useState();

  const [selectedOrganizations, setSelectedOrganizations] = useState([]);

  const [report, setReport] = useState({});
  // ... (Other state variables)

  useEffect(() => {
    // Find the report with the given ID
    const selectedReport = data.find(
      (report) => report.id === parseInt(id, 10)
    );

    // Update the state with the selected report
    setReport(selectedReport || {});

    // Map status to reportStatus and update stepper
    switch (selectedReport?.status) {
      case "Initiated":
        setReportStatus("initiated");
        setActiveStep(2);
        break;
      case "Draft":
        setReportStatus("drafted");
        setActiveStep(1);
        break;
      case "Approved":
        setReportStatus("approved");
        setActiveStep(5);
        break;
      case "Submitted":
        setReportStatus("Submitted");
        setActiveStep(3);
        break;
      case "Acknowledged":
        setReportStatus("Acknowledged");
        setActiveStep(4);
        break;
      // Add more cases as needed
      default:
        setReportStatus("new report");
        setActiveStep(0);
        break;
    }

    // ... (Other useEffect logic)
  }, [id]);

  const steps = [
    { title: "New report" },
    { title: "Drafted" },
    { title: "Initiated" },
    { title: "Submitted" },
    { title: "Acknowledged" },
    { title: "Approved" },
  ];

  const handleSelectedOrganization = (selected) => {
    setSelectedOrganizations(selected);
  };

  useEffect(() => {
    console.log("Selected Organizations:", selectedOrganizations);
  }, [selectedOrganizations]);

  const breadcrumbItems = [
    { title: "Reports", link: "/report" },
    { title: " Report Detail" },
  ];

  return (
    <React.Fragment>
      <Container fluid>
        <div className="">
          <div className="page-content">
            <Row>
              <Col>
                <Breadcrumbs items={breadcrumbItems} />
                <Row style={{ paddingRight: "17px" }}>
                  <ReportButton
                    reportStatus={report.status === reportStatus}
                    setReportStatus={setReportStatus}
                    setActiveStep={setActiveStep}
                    selectedOrganizations={selectedOrganizations}
                    setSelectedOrganization={handleSelectedOrganization}
                  />
                </Row>
                <Row className="px-2 ">
                  {/* {["Submitted", "Acknowledged", "Approved"].includes(
                    report.status
                  ) && (
                    <Row className="px-2 ">
                      <ToggleSubmittedReport />
                    </Row>
                  )} */}
                  <Col lg={6}>
                    <Row>
                      <Card className="mt-4">
                        <CardBody className="mt-2">
                          <h6 className="fw-bold">
                            Your submission no:: 800058228983
                          </h6>
                          <div className="card-width-full">
                            <div className="d-flex">
                              <div className="mt-2 me-3 col">
                                <p className="mb-2">Report name</p>
                                <Input
                                  className="form-control"
                                  placeholder="Your Report Name"
                                />
                              </div>
                              <div className="mt-2 me-3 col">
                                <p className="mb-2">Report Type</p>
                                {/* <select
                                className="form-select"
                                data-choices
                                data-choices-search-false
                                name="choices-single-default"
                                id="idType"
                              >
                                <option value="all">
                                  Select report type
                                </option>
                                <option value="Full Time">File</option>
                                <option value="Part Time">PDF</option>

                                <option value="Freelance">Freelance</option>
                              </select> */}
                                <input
                                  type="text"
                                  className="form-control text-black"
                                  placeholder="File"
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                          <div className="py-1">
                            <div className="d-flex">
                              <div className="mt-2 me-3 col">
                                <p className="mb-2">Year</p>
                                {/* <select
                                className="form-select"
                                data-choices
                                data-choices-search-false
                                name="choices-single-default"
                                id="idType"
                              >
                                <option value="all">...Select Year...</option>
                                <option value="Full Time">2077</option>
                                <option value="Part Time">2078</option>
                                <option value="Internship">2079</option>
                                <option value="Freelance">2080</option>
                              </select> */}
                                <input
                                  type="text"
                                  className="form-control text-black"
                                  placeholder="2080"
                                  readOnly
                                />
                              </div>
                              <div className="mt-2 me-3 col">
                                <p className="mb-2">Month</p>
                                {/* <select
                                className="form-select"
                                data-choices
                                data-choices-search-false
                                name="choices-single-default"
                                id="idType"
                              >
                                <option value="all">...Select Month...</option>
                                <option value="Full Time">Baishakh</option>
                                <option value="Part Time">Jestha</option>
                                <option value="Internship">Ashad</option>
                                <option value="Freelance">Shrawan</option>
                              </select> */}
                                <input
                                  type="text"
                                  className="form-control text-black"
                                  placeholder="Jestha"
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Row>
                  </Col>
                  <Col lg={6} className="px-4 mt-4">
                    <Card
                      style={{
                        width: "100%",
                        height: "223px",
                        paddingTop: "60px",
                      }}
                    >
                      <Stepper
                        steps={steps}
                        activeStep={activeStep}
                        className=" pt-5 fs-10 mx-auto "
                        activeColor="green"
                        completeColor="green"
                      />
                    </Card>
                  </Col>
                </Row>

                <Row className="px-2">
                  <Row>
                    <Card className="p-0">
                      <CardBody className="pt-1">
                        <div className="table-responsive table-card mt-1 w-full">
                          <Table className="table align-middle table-nowrap">
                            <thead style={{ backgroundColor: "#e5edf6" }}>
                              <tr className="text-muted">
                                <td>
                                  H.No 10 share Capital Accounting
                                  Account(Schedule-1)
                                </td>
                              </tr>
                            </thead>
                          </Table>
                        </div>

                        <div className="table-responsive table-card mt-1  w-full">
                          <Table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr className="text-muted">
                                <td>S.N</td>
                                <td>DESCRIPTION</td>
                                <td className="text-center">CREDIT</td>{" "}
                                <td className="text-center">DEBIT</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    01
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Sharing accounting accounts
                                  </span>
                                </td>

                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 51,512600.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span></span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Total
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 51,512600.00`
                                    }
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>

                        <div className="table-responsive table-card  w-full">
                          <Table className="table align-middle table-nowrap">
                            <thead className="table-light ">
                              <tr style={{ backgroundColor: "#e5edf6" }}>
                                <td>
                                  H.No 10 share Capital Accounting
                                  Account(Schedule-2)
                                </td>
                              </tr>
                            </thead>
                          </Table>
                        </div>

                        <div className="table-responsive table-card mt-1  w-full">
                          <Table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr className="text-muted">
                                <td>S.N</td>
                                <td>DESCRIPTION</td>
                                <td className="text-center">CREDIT</td>{" "}
                                <td className="text-center">DEBIT</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  className="table-light fw-bold"
                                  colSpan="12"
                                  style={{ marginBottom: "10px" }}
                                >
                                  Reverse fund
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    01
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Sharing accounting accounts
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 28,5275300.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="form table-light fw-bold"
                                  colSpan="12"
                                >
                                  Other funds
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    02
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Share dividend fund accounting account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    03
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Protected capital fund accounting account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    04
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Employee bonus fund accounting account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    05
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Cooperative education fund accounting
                                    account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    06
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Cooperative development fund account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    07
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Deflict fund account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    08
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Cooperative mnagement fund accounts
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    09
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Balance sheet account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    10
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Community development fund account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 93,500.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    11
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Other risk management fund accounts
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span></span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Total
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 28,368,801.83`
                                    }
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="table-responsive table-card  w-full">
                          <Table className="table align-middle table-nowrap">
                            <thead style={{ backgroundColor: "#e5edf6" }}>
                              <tr className="text-muted">
                                <td>
                                  H.No 10 share Capital Accounting
                                  Account(Schedule-3)
                                </td>
                              </tr>
                            </thead>
                          </Table>
                        </div>

                        <div className="table-responsive table-card mt-1  w-full">
                          <Table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr className="text muted">
                                <td>S.N</td>
                                <td>DESCRIPTION</td>
                                <td className="text-center">CREDIT</td>{" "}
                                <td className="text-center">DEBIT</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    01
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Stabialization fund(in case of union only)
                                    account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : ` 0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    02
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Debt protection fund account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 2,712,67464.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    03
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Undistributed net cash account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span
                                    className="form-control border-0"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    04
                                  </span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    member relief fund account
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `0.00`
                                    }
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span></span>
                                </td>
                                <td className="col-sm-5">
                                  <span
                                    className="form-control border-0 fw-bold"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    Total
                                  </span>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    placeholder={
                                      reportStatus === "new report"
                                        ? ""
                                        : `Rs. 2,712,67464.00`
                                    }
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                    {["submitted", "approved"].includes(reportStatus) && (
                      <Card>
                        <h6 className="mt-3">
                          <strong>Report submitted to</strong>
                        </h6>

                        <Row className="justify-content-start mt-2">
                          <Col lg={10}>
                            <Row>
                              {options.map((option, index) => (
                                <Col key={index} className="text-center mb-3">
                                  <div
                                    className="position-relative image-container px-auto border rounded"
                                    style={{
                                      borderWidth: "3px",
                                      height: "100%",
                                    }}
                                  >
                                    <div className="form-check form-check-success mb-3">
                                      <Input
                                        className="form-check-input custom-rounded position-absolute end-0 top-0 mt-2 me-2"
                                        type="checkbox"
                                        id={`image${index + 1}`}
                                        checked={[0, 3].includes(index)} // Check if the current index is 0 or 3
                                        onChange={() =>
                                          handleCheckboxChange(index)
                                        }
                                      />

                                      <Label
                                        className="form-check-label"
                                        htmlFor={`image${index + 1}`}
                                      />
                                    </div>
                                    <div className="img-container mt-2">
                                      {option.image && (
                                        <img
                                          src={option.image}
                                          className="img-fluid rounded"
                                          alt={`Option ${index + 1}`}
                                          style={{
                                            width: "50%",
                                            height: "auto",
                                            margin: "auto",
                                          }}
                                        />
                                      )}
                                      <div className="text-below-image mt-2 px-2">
                                        <p>
                                          {index === 0
                                            ? "COPO MIS"
                                            : option.label}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Col>
                        </Row>
                      </Card>
                    )}
                  </Row>
                </Row>
              </Col>
            </Row>

            <Row style={{ paddingRight: "17px" }} className="mb-4">
              <ReportButton
                reportStatus={reportStatus === report.status}
                setReportStatus={setReportStatus}
                setActiveStep={setActiveStep}
                selectedOrganizations={selectedOrganizations}
                setSelectedOrganization={handleSelectedOrganization}
              />
            </Row>

            <ModalReport />
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default ReportDetail;
